module.exports = __webpack_public_path__ + "img/default-card.88c828ab.svg";